import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { handleError } from "../../../shared/functions/handleError";
import { IModuleAction } from "../../../shared/interfaces/module/IModule";
import { ModuleService } from "../service";
import ModuleForm from "./ModuleForm";

export const moduleSchema = yup.object({
  name: yup.string().required("validation.required"),
  description: yup.string().required("validation.required"),
  price: yup
    .number()
    .typeError("price must be a number")
    .required("validation.required")
    .min(0, "validation.minLength"),
});
const ModuleUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control } = useForm<IModuleAction>({
    resolver: yupResolver(moduleSchema) as unknown as Resolver<IModuleAction>,
    defaultValues: async () =>
      (await ModuleService.getSingle(Number(id))
        .then((response) => {
          return {
            ...response,
          };
        })
        .catch(handleError)) as unknown as IModuleAction,
  });
  const submitHandler = (formData: IModuleAction) => {
    ModuleService.update(formData, Number(id))
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyUpdated", { title: formData?.name }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ModuleForm isUpdate control={control} />
    </form>
  );
};

export default ModuleUpdate;
